<template>
<section class="button-row px-4 py-8">
    <div class="max-w-5xl mx-auto">
        <div class="flex flex-wrap justify-center -mx-4">
            <div v-for="button in buttons" class="px-4 w-full vt:w-1/3">
                <Button :url="button.url" variant="button-2" class="w-full text-center" :label="button.label"></Button>
            </div>
        </div>
    </div>
</section>
</template>

<script>
export default {

    props: ['data'],
    
    setup(props) {
        return {
            ...props.data
        }
    }

}
</script>